export enum PlanningGenerationType {
    PURCHASE_PRICE = 'PURCHASE_PRICE',
    SALES_VOLUME = 'SALES_VOLUME',
}
